import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Flooring from 'components/flooring';

const FlooringsRoute: React.FC = () =>
{
    return (
        <PermissionGuard
            permission={Flooring.Const.permissions.VIEW}
            fallback={<Pages.Page403 />}
        >
            <Routes>
                <Route path="/" element={<Pages.Floorings />} />
                <Route path="/:id/*" element={<Pages.Flooring />} />
                <Route path="/create" element={<Pages.Flooring />} />
            </Routes>
        </PermissionGuard>
    );
};

export default FlooringsRoute;
